<script>
import moment from "moment";

export default {
  props: {
    value: { type: Date, default: null },
    salidas: { type: Array, default: [] },
  },
  watch: {
    value(newValue) {
      this.$emit("input", newValue);
    },
  },
  computed: {
    minDate() {
      return moment.min(this.salidas.map((d) => moment(d))).toDate();
    },
    maxDate() {
      return moment.max(this.salidas.map((d) => moment(d))).toDate();
    },
  },
};
</script>

<template>
  <!-- https://v2.vcalendar.io/api/v1.0/calendar.html -->
  <!-- NOTA: 
    1- Si colocamos min-date y max-date para desactivar la navegación entre meses deja de tener efecto available-dates así que no los usamos.
    2- from-date está solo para que el calendario cargue en el mes que tiene la primera fecha disponible y no en el mes actual. 
    3- Ocultamos la navegación entre meses con CSS.
  -->
  <v-date-picker
    v-model="value"
    locale="es"
    :is-inline="true"
    :from-date="minDate"
    :available-dates="salidas"
  />
</template>

<style>
.vc-arrows-container {
  display: none;
}
</style>
